import styled from 'styled-components';
import { getColor, getSpace, getGridSpan, getGridSpans, mq } from '../../../stylesheets/tools';

const StyledLivestreamTeaser = styled.div`
  position: relative;
  margin: ${getSpace('l')} 0;

  ${mq('m')} {
    .livestreamTeaser__header {
      width: ${getGridSpan(10)};
      position: relative;
      left: ${getGridSpan(2, 'spread')};
    }
  }

  .livestreamTeaser__tags {
    margin-bottom: 15px;
  }

  .livestreamTeaser__categories {
    padding-bottom: ${getSpace('l')};
  }

  .livestreamTeaser__headline {
    ${getGridSpans('width', { s: 11, m: 7 })}
    padding-bottom: 20px;
  }

  .livestreamTeaser__video-wrapper {
    position: relative;
    left: ${getGridSpan(1, 'spread')};
    padding-bottom: 56.25%;
    height: 0;
    background: ${getColor('lightGray')};
    animation: loadingBg 1s linear infinite alternate;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .livestreamTeaser__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
  }

  .livestreamTeaser__playButton {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    .icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .livestreamTeaser__date {
    position: absolute;
    bottom: -50px;
    left: ${getGridSpan(-1, 'spread')};

    ${mq('m')} {
      bottom: -60px;
      margin-left: 35px;
    }
  }

  .livestreamTeaser__content {
    padding-top: ${getSpace('s')};
  }

  .livestreamTeaser__text {
    ${getGridSpans('width', { s: 11, m: 8 })}

    ${mq('m')} {
      margin-left: ${getGridSpan(2, 'spread')};
    }
  }
`;

export default StyledLivestreamTeaser;
